module.exports = __webpack_public_path__ + "img/Z61_08.bc3dba52.jpg";